export default __webpack_public_path__ + "../staticImages/android-chrome-256x256.png";